export class Address {
    addressId: number;
    addressTitle: string;
    address1: string;
    address2: string;
    address3: string;
    addressTown: string;
    addressCounty: string;
    addressPostcode: string;
    addressTel: string;
    addressEmail: string;
    addressLong: string;
    addressLat: string;
    addressCountry: string;
    formattedForHTML: string;

    constructor(data?: any) {
        data = Object.assign({}, data);
        this.addressId = data.addressId || null;
        this.addressTitle = data.addressTitle || '';
        this.address1 = data.address1 || '';
        this.address2 = data.address2 || '';
        this.address3 = data.address3 || '';
        this.addressTown = data.addressTown || '';
        this.addressCounty = data.addressCounty || '';
        this.addressPostcode = data.addressPostcode || '';
        this.addressTel = data.addressTel || '';
        this.addressEmail = data.addressEmail || '';
        this.addressLong = data.addressLong || '';
        this.addressLat = data.addressLat || '';
        this.addressCountry = data.addressCountry || 'gb';
        this.formattedForHTML = this.displayForHTML();
    }

    displayForLine(siteTitle?: string) {
        return this.displayWithJoin(', ', siteTitle);
    }

    displayForHTML() {
        return this.displayWithJoin('<br/>');
    }

    displayWithJoin(character: string, siteTitle?: string) {
        // dont duplicate site title
        const parts = [];

        if (this.address1 !== siteTitle) parts.push(this.address1);
        if (this.address2) parts.push(this.address2);
        if (this.address3 && (this.address2 !== this.address3)) parts.push(this.address3);
        if (this.addressTown) parts.push(this.addressTown);
        if (this.addressCounty && (this.addressCounty !== this.addressTown)) parts.push(this.addressCounty);
        // if (this.addressCountry) parts.push(this.addressCountry);
        if (this.addressPostcode) parts.push(this.addressPostcode);

        return parts.join(character);
    }

    serialise() {
        return {
            addressId: this.addressId,
            addressTitle: this.addressTitle,
            address1: this.address1,
            address2: this.address2,
            address3: this.address3,
            addressTown: this.addressTown,
            addressCounty: this.addressCounty,
            addressPostcode: this.addressPostcode,
            addressTel: this.addressTel,
            addressEmail: this.addressEmail,
            addressLong: this.addressLong,
            addressLat: this.addressLat
        }
    }

    clone(): Address {
        return new Address(this); // Uses constructor for deep copy
    }
}
